import React from 'react';
import { Customer } from '../../../types';

interface CustomerEditFormProps {
  selectedCustomer: Customer;
  submitting: boolean;
  error: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const inputClass = 'w-full theme-border rounded px-2 py-1 text-sm focus:ring-1 focus:ring-blue-500 focus:border-transparent theme-bg-primary theme-text-primary';

const CustomerEditForm: React.FC<CustomerEditFormProps> = ({
  selectedCustomer,
  submitting,
  error,
  onChange,
  onSubmit,
  onCancel,
}) => (
  <form onSubmit={onSubmit} className="space-y-3">
    {error && (
      <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
        {error}
      </div>
    )}

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-primary mb-0.5">
        Customer Name <span className="text-red-500">*</span>
      </label>
      <input name="item" value={selectedCustomer.item} onChange={onChange} required className={inputClass} placeholder="Enter official name" />
    </div>

    <div className="grid grid-cols-2 gap-3">
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-primary mb-0.5">
          Client ID <span className="text-red-500">*</span>
        </label>
        <input name="client_id" value={selectedCustomer.client_id} onChange={onChange} required className={inputClass} placeholder="Enter client ID" />
      </div>
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-primary mb-0.5">
          Short Name <span className="text-red-500">*</span>
        </label>
        <input name="short_name" value={selectedCustomer.short_name} onChange={onChange} required className={inputClass} placeholder="Enter short name" />
      </div>
    </div>

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-primary mb-0.5">Monday ID</label>
      <input name="monday_id" value={selectedCustomer.monday_id || ''} onChange={onChange} className={inputClass} placeholder="Enter Monday ID" />
    </div>

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-primary mb-0.5">Funding Type</label>
      <select name="funding_type" value={selectedCustomer.funding_type || ''} onChange={onChange} className={inputClass}>
        <option value="">Select Funding Type</option>
        <option value="On-Call">On-Call</option>
        <option value="Project Management">Project Management</option>
      </select>
    </div>

    <div className="grid grid-cols-1 gap-3">
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-primary mb-0.5">Status</label>
        <select name="status" value={selectedCustomer.status} onChange={onChange} className={inputClass}>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-primary mb-0.5">Client Drive Name</label>
        <input name="client_drive_name" value={selectedCustomer.client_drive_name || ''} onChange={onChange} className={inputClass} placeholder="Enter drive name" />
      </div>
    </div>

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-primary mb-0.5">Google Drive URL</label>
      <input name="google_drive_url" value={selectedCustomer.google_drive_url || ''} onChange={onChange} type="url" className={inputClass} placeholder="https://drive.google.com/..." />
    </div>

    <div className="flex gap-2 pt-3">
      <button
        type="button"
        onClick={onCancel}
        className="flex-1 px-3 py-1.5 theme-border rounded hover:opacity-80 transition-opacity text-sm theme-bg-secondary theme-text-primary"
        disabled={submitting}
      >
        Cancel
      </button>
      <button
        type="submit"
        disabled={submitting}
        className="flex-1 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded hover:shadow-lg transition-shadow disabled:opacity-50 text-sm"
      >
        {submitting ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  </form>
);

export default CustomerEditForm;
